import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import { Box, FormHelperText, Grid, Typography } from '@mui/material';
import Dialog from '../../../common/Dialog';
import InputText, { InputSelectNative } from '../../../common/Form';
import PhotoUpload from '../../../common/PhotoUpload';


class Articles extends Component {
    state = { 
        article_name: this.props.article ? this.props.article.article_name : "",
        article_price: this.props.article ? this.props.article.article_price : "",
        article_brand: this.props.article ? this.props.article.article_brand : "",
        article_remarks: this.props.article ? this.props.article.article_remarks : "",
        article_desc: this.props.article ? this.props.article.article_desc : "",
        article_photo: null,
        errors: {}
    }

    handleChange = (e) => {
        const { name, value} = e.target;
        // TO DO add regex float
        const regexF = /^[-+]?[0-9]*\.?[0-9]+$/ // accept negatives
        // const regexF = /^(?[0-9]+([.][0-9]*)?|[.][0-9]+)$/
        const floatFields = [ "article_price"]

       if (!floatFields.includes(name) ){
            this.setState({
                [name]: value
            })
        } else if (floatFields.includes(name) && (regexF.test(value) || value === "")){
            this.setState({
                [name]: parseFloat(value)
            })
        }     
    }

    setPhotos = (name, list) => {
        console.log("[INFO] SETPHOTOS", name, list);
        
        this.setState({
            [name]:list
        })
    }
    validate = () => {
        let noError = true
        let errors = {} 
        let required = [
            "article_name",
            "article_price",
            "article_brand",
            "article_photo",
        ]

        console.log('====================================');
        console.log({required});
        console.log('====================================');
        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        this.setState({
            errors
        })
        return noError
    }
    
    handleSubmit = async () => {

        if( this.validate() ){
            let data = {}
            data.article_name = this.state.article_name
            data.article_brand = this.state.article_brand
            data.article_price = parseFloat(this.state.article_price)
            data.article_remarks = this.state.article_remarks
            // data.article_desc = this.state.article_desc
            data.article_photo = this.state.article_photo           
            
            console.log('====================================');
            console.log("submit article", {data});
            console.log('====================================');
        
            await this.props.newArticle(data)

            // // if NoErrors ...
            if(this.props.STATE.articles.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.articles.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    validateUpdate = () => {
        let noError = true
        let errors = {} 
        let required = [
            "article_name",
            "article_price",
            "article_brand",
        ]
            
        console.log('====================================');
        console.log({required});
        console.log('====================================');
        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        this.setState({
            errors
        })
        return noError
    }
    handleSubmitUpdate = async () => {

        if( this.validateUpdate() ){
            let data = Object.assign({}, this.props.article)
            data.article_name = this.state.article_name
            // data.article_desc = this.state.article_desc
            data.article_brand = this.state.article_brand
            data.article_remarks = this.state.article_remarks
            data.article_price = parseFloat(this.state.article_price)
            
            console.log('====================================');
            console.log("submit article", {data});
            console.log('====================================');
        
            await this.props.updateArticle(data)
            
            // // if NoErrors ...
            if(this.props.STATE.articles.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.articles.error}`)
            } else { 
                this.props.notif("success", "l'article a été modifié")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        const { update } = this.props;
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <Dialog
                title={update ? "Modifier l'article" :`Nouvel article`}
                close={this.props.handleClose}
                submitAction={update ? this.handleSubmitUpdate : this.handleSubmit}
                appBar
                maxWidth="sm"
            >
                <Grid container >
                    {/* <Grid container item xs={12} sm={6} > */}
                        <Grid item xs={12}>
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="article_name"
                                error={this.state.errors.article_name}
                                value={this.state.article_name}
                                name="article_name"
                                label="Intitulé"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="article_brand"
                                error={this.state.errors.article_brand}
                                value={this.state.article_brand}
                                name="article_brand"
                                label="Marque"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="article_price"
                                error={this.state.errors.article_price}
                                value={this.state.article_price}
                                name="article_price"
                                label="Prix"
                                type="number"
                            />
                        </Grid>
                    {/* </Grid>
                    <Grid container item xs={12} sm={6} > */}
                        {/* <Grid item xs={12}>
                            <InputText
                                onChange={this.handleChange}
                                multiline
                                rows={3}
                                id="article_desc"
                                error={this.state.errors.article_desc}
                                value={this.state.article_desc}
                                name="article_desc"
                                label="Description"
                            />
                        </Grid>  */}
                        
                        <Grid item xs={12}>
                            <InputText
                                onChange={this.handleChange}
                                multiline
                                rows={3}
                                id="article_remarks"
                                error={this.state.errors.article_remarks}
                                value={this.state.article_remarks}
                                name="article_remarks"
                                label="Remarques"
                            />
                        </Grid>
                    {/* </Grid> */}
                    {!this.props.update &&
                        <>
                            <Grid item xs={12}>
                                <hr />
                                <Box p={1}>
                                    <Typography color="primary" variant="button" style={{fontWeight: "bold"}}>Photos</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box p={1}>
                                    <PhotoUpload id="av" label="Photos" setPhoto={(pic) => this.setPhotos("article_photo", pic)} photos={this.state.article_photo === null ? [] : this.state.article_photo } error={this.state.errors.article_photo} />
                                </Box>
                            </Grid>
                        </>
                    }
                </Grid>      
            </Dialog>
        );
    }
}

export default Articles;